import React from "react";
import "./Card.css";

function Card({
  allQuestionsCount,
  matchedUser,
  userContestRanking,
  easySolved,
  mediumSolved,
  hardSolved,
  totalSolved,
}) {
  return (
    <div className="card__profile">
      <h2>LeetCode Statistics</h2>
      <div className="card__profile-content">
        <div>
          <h3>Number of Questions</h3>
          <ul>
            {allQuestionsCount.map((item) => (
              <li key={item.difficulty}>
                {item.difficulty}: {item.count}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3>Solved Questions</h3>
          <p>Total Solved: {totalSolved}</p>
          <p>Easy: {easySolved}</p>
          <p>Medium: {mediumSolved}</p>
          <p>Hard: {hardSolved}</p>
        </div>
        <div>
        <h3>Contest Ranking</h3>
        <p>Rating: {userContestRanking.rating}</p>
        <p>Global Ranking: {userContestRanking.globalRanking}</p>
        <p>Top Percentage: {userContestRanking.topPercentage}%</p>
        <p>Badge: {userContestRanking.badge.name}</p>
        </div>
        
        <div>
          <h3>Contributions</h3>
          <p>Points: {matchedUser.contributions.points}</p>
        </div>
      </div>
    </div>
  );
}

export default Card